import { useEffect, useState } from "react";
import { API_URL } from "../../const";
import { Oval } from "react-loader-spinner";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import AutoCompleteInput from "../../component/filter/customAutocomplete";
import axios from "axios";
import moment from "moment";

const PhoneLog = () => {

    const [loading, setLoading] = useState(true);
    const [clientList, setClientList] = useState([]);
    const [phonelogtList, setPhoneLogeList] = useState([]);
    const [isRefreshing, setRefreshing] = useState(false);
    const [formData, setFormData] = useState({
        client_name: "",
        phone_number: "",
        created_date: new Date(),
        remark: ""
    });

    const getClient = () => {
        axios.post(API_URL.CLIENT_LIST, {}).then((res) => {
            if (res.data.status === 1) {
                setClientList(res.data.data);
            }
        });
    };

    const getPhoneLoge = () => {
        axios.post(API_URL.PHONE_LOG_LIST, {}).then((res) => {
            if (res.data.status === 1) {
                let sortData = res.data.data.sort((a, b) => {
                    return new Date(b.created_date)  - new Date(a.created_date);
                });
                setPhoneLogeList(sortData);
            }
            setLoading(false);
        });
    };


    const onSaveData = () => {
        let url = API_URL.PHONE_LOG_SAVE;
        let body = { ...formData };
        axios.post(url, body).then((response) => {
            if (response.data.status === 1) {
                setFormData({
                    name: "",
                    phone_number: "",
                    created_date: new Date(),
                    remark: "",
                });
                setRefreshing(true);
                setTimeout(()=>{
                    setRefreshing(false);
                },1000);
                setLoading(true);
                getPhoneLoge();
            } else {
                toast.error('Something went wrong..', { autoClose: 3000, position: "top-center", })
            }
        });
    }

    useEffect(() => {
        getClient();
        getPhoneLoge();
    }, []);


    const isValidForm = () => {
        return formData.client_name && formData.phone_number;
    };



    return (
        <>
            <div className="w-100">
                <div className="card shadow-sm ctm-border-radius">
                    <div className="card-body align-center">
                        <h4 className="title card-title float-left mb-0">
                            PhoneLog
                        </h4>
                    </div>
                    <div className="card-body">
                        <div className="row align-center">
                            <div className="col-md-8">
                                <div className="form-group edit-name">
                                    <label>Connected Person</label>
                                    {clientList.length > 0 && !isRefreshing && <AutoCompleteInput options={(clientList.map((d) => {
                                        return { name: d.firm_name, id: d.id, phoneNumber: d.person_one_no }
                                    }))}
                                        placeholder="Select Connected Person" value={formData.client_name}
                                        onSelect={(event) => {
                                            setFormData({
                                                ...formData,
                                                client_name: event.name,
                                                phone_number: event.phoneNumber
                                            })
                                        }}
                                    />}
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group edit-name">
                                    <label>Phone Number</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="phone"
                                        value={formData.phone_number}
                                        onChange={(e) => {
                                            setFormData({
                                                ...formData,
                                                phone_number: e.target.value
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group edit-name">
                                    <label>Date</label>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control"
                                        placeholderText="Select Date.."
                                        selected={formData.created_date}
                                        onChange={(date) => {
                                            setFormData((prevState) => ({ ...prevState, created_date: date }));
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group edit-name">
                                    <label>Remark</label>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        value={formData.remark}
                                        onChange={(e) => { setFormData({ ...formData, remark: e.target.value }) }}
                                    ></textarea>
                                </div>
                            </div>
                            <div className="col-md-12 text-right mt-3">
                                <button
                                    className="btn btn-theme ctm-border-radius text-white"
                                    onClick={onSaveData}
                                    disabled={!isValidForm()}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-100">
                <div className="card shadow-sm ctm-border-radius">
                    <div className="card-body">
                        {loading ? (
                            <Oval
                                height={60}
                                width={60}
                                color="#7539ff"
                                wrapperStyle={{ justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel="oval-loading"
                                secondaryColor="#7539ff"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                            />
                        ) : (
                            <table
                                className="table custom-table table-bordered"
                            >
                                <thead>
                                    <tr>
                                        <th>Client Name</th>
                                        <th>Phone Number</th>
                                        <th>Date</th>
                                        <th>Remark</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {phonelogtList.map((res, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{res.client_name}</td>
                                                <td>{res.phone_number}</td>
                                                <td>{moment(res.created_date).format("DD/MM/YYYY")}</td>
                                                <td>{res.remark}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PhoneLog;
